export class DoctorCurrentNationality {
  nationalityName: string;
  status: string;
  id: number;
}
